// Sync direction of a field-mapping setting.
//
// Every sync-rule setting carries `settingSchema.direction` so the two sync
// paths use SEPARATE mappings (sharing one mapping for both directions caused
// conflicts):
//
//   - "Shopify2CRM"  — Shopify webhook fires → backend maps Shopify payload
//                      into Zoho CRM. Used by every Shopify webhook handler.
//   - "CRM2Shopify"  — Zoho CRM workflow fires → backend maps the CRM record
//                      out to Shopify. Used by the Zoho → Shopify outbound
//                      workflow functions (see setZohoWorkflowsStatus).
//
// Legacy settings saved before this field existed have no `direction`; they
// are webhook-driven, so treat a missing value as "Shopify2CRM".
export const DIRECTION_SHOPIFY_TO_CRM = "Shopify2CRM";
export const DIRECTION_CRM_TO_SHOPIFY = "CRM2Shopify";

export const DIRECTION_LABELS = {
  [DIRECTION_SHOPIFY_TO_CRM]: "Shopify to CRM",
  [DIRECTION_CRM_TO_SHOPIFY]: "CRM to Shopify",
};

/** Normalise a stored direction value; missing/unknown → Shopify2CRM. */
export const normaliseDirection = (d) =>
  d === DIRECTION_CRM_TO_SHOPIFY
    ? DIRECTION_CRM_TO_SHOPIFY
    : DIRECTION_SHOPIFY_TO_CRM;

// Trigger events for CRM2Shopify settings. These are Zoho CRM workflow
// events, NOT Shopify webhook topics — no Shopify webhook is ever registered
// for a CRM2Shopify setting. The `value`/`apiName` strings are the contract
// with the REST API: the Zoho → Shopify workflow functions look up the
// CRM2Shopify setting whose module + triggerApiName match the firing event.
// Values deliberately end in _CREATE/_UPDATE/_DELETE so the Sync Rules UI
// buckets them into the same Create/Update/Delete columns as webhook topics.
export const CRM_TRIGGER_LIST = [
  {
    value: "CRM_RECORD_CREATE",
    label: "Record created (CRM workflow)",
    category: "Zoho CRM",
    apiName: "crm/record/create",
  },
  {
    value: "CRM_RECORD_UPDATE",
    label: "Record updated (CRM workflow)",
    category: "Zoho CRM",
    apiName: "crm/record/update",
  },
  {
    value: "CRM_RECORD_DELETE",
    label: "Record deleted (CRM workflow)",
    category: "Zoho CRM",
    apiName: "crm/record/delete",
  },
];
